import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToDDMMYYYY, dayToHour } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import { downloadCSVFile } from "../../../api/apiClient";
import ShowIButtonName from "../../commoncomponents/showIButtonName";

function HourlyTotalSummary(props) {
  const report = props.reportDetails;
  const showTempA = report.assetTempA !== undefined ? report.assetTempA : report.tempA > 0;
  const showTempB = report.assetTempB !== undefined ? report.assetTempB : report.tempB > 0;
  let assetName= props.assetCustomerName;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Asset</th>
          <th>Depot</th>
          <th>Start Date</th>
          <th>Total Days</th>
          <th>Days in use</th>
          <th>Utilisation</th>
          <th>
            Duration &nbsp;
            <i
              class="fa fa-info-circle text-primary"
              title="First Engine ON to Last Engine OFF"
            ></i>
          </th>
          <th>
            Duration Outside Depot &nbsp;
            <i
              class="fa fa-info-circle text-primary"
              title="First Departure until Last Entry or Engine OFF"
            ></i>
          </th>
          <th>
            All trips &nbsp;
            <i
              class="fa fa-info-circle text-primary"
              title="Trips + Virtual Trips"
            ></i>
          </th>
          <th>
            Trips/Hour&nbsp;{" "}
            <i
              class="fa fa-info-circle text-primary"
              title="(All Trips / Duration outside depot) / 1 hour"
            ></i>
          </th>
          <th>Distance</th>
          <th>
            Distance/Hour&nbsp;{" "}
            <i
              class="fa fa-info-circle text-primary"
              title="(Total Distance / Duration outside depot)/ 1 hour"
            ></i>
          </th>
          <th>Parked Idle</th>
          <th>Duress</th>
          <th>Powercut</th>
          <th>Low Battery</th>
          {showTempA && <th>Temp A</th>}
          {showTempB && <th>Temp B</th>}
          <th>Overspeed</th>
          <th>Harsh Accel</th>
          <th>Harsh Brake</th>
          <th>Harsh Corner</th>
          <th>OH&S</th>
          <th>GSM Loss</th>
          <th>GPS Loss</th>
          <th>Processed</th>
        </tr>
      </thead>
      <tbody>
      <tr className={report.allTrips==0 ? "yellowBg" : ""}>
          <td>{report.asset}
          <br />
          <ShowIButtonName 
                  ibuttonId={report.ibuttonId}
                  serialno={report.serialno} 
                  iButtonName={report.iButtonName}
                />
          </td>
          <td>{report.depot}</td>
          <td style={{ whiteSpace: "nowrap" }}>
            {utcToDDMMYYYY(report.startDate)}
          </td>

          <td>{report.totalDays}</td>
          <td>{report.daysInUse}</td>
          <td>{report.utilisation}%</td>
          <td>{dayToHour(report.duration)}</td>
          <td>{dayToHour(report.durationOutsideDepot)}</td>
          <td>{report.allTrips}</td>
          <td>{report.tripPerHour}</td>
          <td>{rounding(report.distance)}</td>
          <td>{report.distancePerHour}</td>
          <td>{report.parkedIdle}</td>
          <td>{report.duress}</td>
          <td>{report.powercut}</td>
          <td>{report.lowBattery}</td>
          {showTempA && <td>{report.tempA}</td>}
          {showTempB && <td>{report.tempB}</td>}
          <td>{report.speed}</td>
          <td>{report.harshAccel}</td>
          <td>{report.harshBrake}</td>
          <td>{report.harshCorner}</td>
          <td>{report.ohs}</td>
          <td>{report.gsmLoss}%</td>
          <td>{report.gpsLoss}%</td>
          <td>{report.processed}</td>
        </tr>
      </tbody>
    </Table>
  );
  const handleDownloadExcel = () => {
    let reportArr = [];
    reportArr.push(props.reportDetails);
      downloadCSVFile(reportArr,"AssetRunning_HourlytotalSummary",assetName,timeZone);
  };
  return (
    <ToggleBar
      download={handleDownloadExcel}
      caption="Hourly Total Summary"
      icon="fa-clock-o"
      color="#337AB7"
      content={data}
    />
  );
}

export default HourlyTotalSummary;
